import { HttpResult, unloadedAsyncState } from "widgets-for-react"
import { DonationFormState, DonationFormType, getAmountsForForm, PredefinedAmountsType, Step3PersonalData, PredefinedValues, validators, isRecurringFormType, getManualAmount, initStep3PersonalData } from "./donationFormBlock.state"
import { Validator } from "../../../../../../Shared/Frontend/validators/validator"
import { convertPathToUrl } from "./utils"

export interface DonationApiResponseParsed {
  predefinedAmounts: PredefinedAmountsType
  submitButton: string
  monthlyText?: string
  yearlyText?: string
  formFields: PredefinedValues
  customTitle?:string
  optionForMachtiging: boolean
  productId: string
  SelectedFormType: DonationFormType
  formTypeOptions: DonationFormType[]
  successUrl: string
  failedUrl: string
  cancelUrl: string
}


export const donationFormRequest: (
    formId: number
  ) => Promise<HttpResult<DonationApiResponseParsed>> = 
  async (
    formId
  ) => {
    try {
      const endpoint = `/api/drupal/donationForm?formId=${formId}`
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
      
      let res = await fetch(endpoint, {
        method: 'get', credentials: 'include', headers: headers
      })

      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      
      const value = parseDonationFormStep1(json, formId)

      return {
        kind: 'result',
        status: 200,
        value: value
      }
    } catch (e) {

      console.error(`Error when fetching donationForm`)
      console.error(JSON.stringify(e))

      return {
        kind: 'failed',
        status: 500
      }
    }
  }

const parseDonationFormStep1 = (json:any, formId:number) : DonationApiResponseParsed => {
  const amounts = parsePredifindedAmounts(json);
  const formTypeOptions = parseFormTypeOptions(json);
  const formFields: PredefinedValues = { drupalformId: formId }

  return {
    predefinedAmounts:amounts,
    formFields :formFields,
    submitButton: json.field_verzendknop[0].value,
    monthlyText: json.field_omschrijving_maandelijks_k[0]?.value,
    yearlyText: json.field_omschrijving_yearly? json.field_omschrijving_yearly[0]?.value : undefined,
    customTitle: json.field_preset_title_single_1 ? json.field_preset_title_single_1[0]?.value : null,
    productId: json.field_product_id?.[0]?.value,
    optionForMachtiging: json.field_optie_tot_machtiging ? json.field_optie_tot_machtiging[0]?.value : false,
    SelectedFormType: formTypeOptions.length > 1 ? formTypeOptions[1]: formTypeOptions[0],
    formTypeOptions: formTypeOptions,
    successUrl: json.field_page_succesful_payment?.[0]?.url,
    failedUrl: json.field_page_failed_payment?.[0]?.url,
    cancelUrl: json.field_page_cancelled_payment?.[0]?.url,
  }
}

const parsePredifindedAmounts = (json: any): PredefinedAmountsType => ({
  "single-sign-on": {
    minimumAmount:json.field_minimum_amount_single[0].value,
    maximumAmount: json.field_maximum_amount_single?.[0]?.value || 5000,
    amounts:[1,2,3].map(input => ({
      amount: json[`field_preset_amount_single_${input}`][0].value,
      button: json[`field_preset_button_single_${input}`][0].value,
      explainerText: json[`field_preset_desc_single_${input}`][0]?.value,
    })),
    selectedIndex: 1,
  },
  "monthly-sign-on": {
    minimumAmount:json.field_minimum_amount_recurring[0].value,
    maximumAmount: json.field_maximum_amount_recurring?.[0]?.value || 5000,
    amounts:[1,2,3].map(input => ({
      amount: json[`field_preset_amount_recurring_${input}`][0].value,
      button: json[`field_preset_button_recurring_${input}`][0].value,
      explainerText: json[`field_preset_desc_recurring_${input}`][0]?.value,
    })),
    selectedIndex: 1,
  },
  "yearly-sign-on": json.field_minimum_amount_yearly && json.field_minimum_amount_yearly[0] ?{
    minimumAmount:json.field_minimum_amount_yearly[0]?.value,
    maximumAmount: json.field_maximum_amount_yearly?.[0]?.value || 5000,
    amounts:[1,2,3].map(input => ({
      amount: json[`field_preset_amount_yearly_${input}`][0]?.value,
      button: json[`field_preset_button_yearly_${input}`][0]?.value,
      explainerText: json[`field_preset_desc_yearly_${input}`][0]?.value,
    })),
    selectedIndex: 1,
  } : {
    minimumAmount:json.field_minimum_amount_recurring[0].value,
    maximumAmount: json.field_maximum_amount_yearly?.[0]?.value || 5000,
    amounts:[1,2,3].map(input => ({
      amount: json[`field_preset_amount_recurring_${input}`][0].value,
      button: json[`field_preset_button_recurring_${input}`][0].value,
      explainerText: json[`field_preset_desc_recurring_${input}`][0]?.value,
    })),
    selectedIndex: 1,
  },
})
/*
express|Eenmalig express
single-sign-on|Eenmalig met aanmelden
recurring-sign-on|Maandelijkse incasso
yearly-sign-on|Jaarlijkse incasso
choiche-sign-on|Keuze tussen eenmalig en maandelijks
choice-single-yearly|Keuze tussen eenmalig en jaarlijks
choice-monthly-yearly|Keuze tussen maandelijks en jaarlijks
choice-all|Keuze tussen eenmalig, maandelijks en jaarlijks*/
const parseFormTypeOptions = (json: any): DonationFormType[] => {
  const type = json.field_formulier_type[0].value
  switch (type) {
    case 'express': return ['express']
    case 'single-sign-on': return ['single-sign-on']
    case 'recurring-sign-on': return ['monthly-sign-on']
    case 'yearly-sign-on': return ['yearly-sign-on']
    case 'choiche-sign-on': return ['single-sign-on', 'monthly-sign-on']
    case 'choice-single-yearly': return ['single-sign-on', 'yearly-sign-on']
    case 'choice-monthly-yearly': return ['monthly-sign-on', "yearly-sign-on"]
  }
  return ['single-sign-on', 'monthly-sign-on', 'yearly-sign-on']
}

export const submitForm: (state: DonationFormState, recaptcha:string) => Promise<HttpResult<{}>> =
  async (state, recaptcha) => {
    if (state.step == "1-Unloaded") return { kind: "failed", status: 0 }
    
    try {
      const endpoint = `/api/v1/payments/donate`
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      const predefinedAmounts = getAmountsForForm(state)
      const manualAmount = getManualAmount(state)

      const formKind = state.productId 
        ? "donation_form_with_product"
        : "donation_form"

      const input = {
        Email: state.input.email,
        ...(state.step == '3-PersonalForm'
          ? {
              Straat: state.input.street,
              Initalen: state.input.firstName,
              Geslacht: state.input.salutation,
              Tussenvoegsel: state.input.insertion,
              Huisnummer: state.input.houseNumber,
              Postcode: state.input.postalCode,
              Telefoon: state.input.phone,
              Nieuwsbrief: state.input.acceptNewsLetter,
              Achternaam: state.input.lastName,
              Plaats: state.input.city,
              Email: state.input.email,
              Toevoeging: state.input.houseNumberAddition,
              IBAN: state.input.iban,
            }
          : {}),
      }
      
      const returnUrls =
      {
        SuccessUrl: convertPathToUrl(state.successUrl),
        FailedUrl: convertPathToUrl(state.failedUrl),
        CancelUrl: convertPathToUrl(state.cancelUrl),
      }

      const body = 
      {
        FormID: state.formValues.drupalformId,
        ProductId: state.productId,
        FormKind: formKind,
        Formulier: state.title,
        Betaalmethode: state.step == "3-PersonalForm" && state.input.machtigingSelected ? "Machtiging" : "iDeal" ,
        Donatie : state.selectedFormType == 'monthly-sign-on' ? "Maandelijks" : state.selectedFormType == 'yearly-sign-on' ? "Jaarlijks" : "Eenmalig",
        SelectAmount: predefinedAmounts.selectedIndex ? predefinedAmounts.amounts[predefinedAmounts.selectedIndex].amount.toString() : "anders",
        Bedrag: predefinedAmounts.selectedIndex ? predefinedAmounts.amounts[predefinedAmounts.selectedIndex].amount : manualAmount,
        Voorwaarden: "", //?
        ... input,
        ... returnUrls,
        recaptcha
      }

      let res = await fetch(endpoint, {
        method: 'post', credentials: 'include', headers: headers, body: JSON.stringify(body)
      })

      if (!res.ok) throw Error(res.statusText)
      const redirectURL = await res.text()

      window.location.href = redirectURL

      return {
        kind: 'result',
        status: 200,
        value: {}
      }
    } catch (e){
      console.log(e)
      return {
        kind: 'failed',
        status: 500
      }
    }
  }

export const createCustomStep3 = (formState: DonationFormState, amount: number) => {
  if (formState.step !== "2-AmountForm") return formState

  const recurring = isRecurringFormType(formState)
  const validator = recurring ? validators.recurringDonationValidator :validators.singleDonationValidator
  const input = initStep3PersonalData(recurring)

  let predefined = formState.predefinedAmounts
  const keys = Object.keys(formState.predefinedAmounts) as Array<keyof typeof formState.predefinedAmounts>
  keys.map(key => {
    predefined[key].manualAmount = amount
  })

  const newStep: DonationFormState = {
    ...formState,
    step: '3-PersonalForm',
    input,
    predefinedAmounts: predefined,
    isPropositionDonation: true,
    selectedFormType: "monthly-sign-on",
    validatorInput: {},
    validator: validator.setValueToValidate(formState.input, formState.input),
    zipCodeLoader: unloadedAsyncState(),
    recaptcha: ""
  }

  return newStep
}